import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Col } from 'react-flexbox-grid'

import { FaIcon } from '../../../shared/components'
import DeleteCategoryPopupSimGolf from './popups/delete_category_popup_sim_golf'
import AddEditCategoryPopupSimGolf from './popups/add_edit_category_popup_sim_golf';

const CategoryHeaderSimGolf = ({
  name,
  opened,
  onClick,
  loadingData,
  color,
  deleteCategory,
  id,
  specialStatus,
  categories,
  updateCategoriesSimGolf,
  updateURL,
  userIsCustomerManager,
}) => {
  const [displayPopup, setDisplayPopup] = useState(false)
  const [openSideDrawer, setOpenSideDrawer] = useState(false)

  const handleDeleteCategory = () => {
    setDisplayPopup(false)
    deleteCategory(id)
  }

  return (
    <Fragment>
      <div className='list_header_sim_golf'>
        <div className={ `${opened && 'table_open'} row_container` } onClick={ onClick }>
          <Col xs={ 11 }>
            <span className='category_color' style={ { content: '\f111', height: '8px', width: '8px', borderRadius: '50%', display: 'inline-block', marginRight: '5px', backgroundColor: color, marginLeft: '15px' } }/>
            <span className='title'>
              { name }
            </span>
            { loadingData && (
              <Fragment>
                <span>
                  <span className='category_preloader_container'>
                    <span className='category_preloader' />
                  </span>
                </span>
              </Fragment>
            )}
          </Col>
          <Col xs={ 1 } className='arrow_icon'>
            <FaIcon icon={ opened ? 'angle-up' : 'angle-down' } className='pull-right' />
          </Col>
        </div>
        { opened &&
          <span className='action_icons_container'>
            <div className={`${userIsCustomerManager ? '' : 'disabled'} pencil_icon`} onClick={ () => setOpenSideDrawer(true) }>
              <img src={ require('pen.svg') }/>
            </div>
            <div
              xs={ 1 }
              className={ `${specialStatus !== null || userIsCustomerManager ? '' : 'disabled' } trash_icon` }
              onClick={ () => specialStatus === null && setDisplayPopup(true) }
              title={specialStatus !== null && window.I18n.t('customer_center_comp.components.sim_golf_buttons.can_not_be_deleted') }
            >
              <img src={ require('trash.svg') }/>
            </div>
          </span>
        }
      </div>
      <table style={ {display: 'none'} }>
        <tbody />
      </table>
      { displayPopup &&
        <DeleteCategoryPopupSimGolf
          displayPopup={ displayPopup }
          setDisplayPopup={ setDisplayPopup }
          name={ name }
          deleteCategory={ handleDeleteCategory }
        />
      }
      {openSideDrawer &&
        <AddEditCategoryPopupSimGolf
          displayPopup={ openSideDrawer }
          setDisplayPopup={ setOpenSideDrawer }
          title={ window.I18n.t('customer_center_comp.components.drawer.edit_title') || '' }
          categories={ categories }
          name={ name }
          opened={ opened }
          onClick={ onClick}
          loadingData={ loadingData }
          color={ color }
          deleteCategory={ handleDeleteCategory }
          id={ id }
          displayDeletePopup={ displayPopup }
          setDisplayDeletePopup={ setDisplayPopup }
          updateCategoriesSimGolf={ updateCategoriesSimGolf }
          updateURL={ updateURL }
        />
      }
    </Fragment>
  )
}

CategoryHeaderSimGolf.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  opened: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  updateCategoriesSimGolf: PropTypes.func.isRequired,
  categories: PropTypes.object.isRequired,
  userIsCustomerManager: PropTypes.bool.isRequired,
  specialStatus: PropTypes.string,
  updateURL: PropTypes.string,
  loadingData: PropTypes.bool,
}

export default CategoryHeaderSimGolf
